import React, { useState, useCallback, useEffect } from 'react';
import { OntotisDropDown, PositionDropDown } from '../../../utils/types';
import { addPerson } from '../../../utils/apicall/personsApi';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { getOntotisDropDown, getPositionsDropDown } from '../../../utils/apicall/commonApi';
import { handleError, ApiError } from '../../../utils/error/error';
import { processError } from '../../../utils/error/errorUtils';
import NotFound from '../../common/404';
import GeneralErrorPage from '../../common/general-error';
import ErrorMessage from '../../../components/errorMessage';
import { CONFIG } from '../../../utils/config';

const PersonAdd: React.FC = () => {
 // const { id } = useParams<{ id: string }>();
  const [ontotisDropDown, setOntotisDropDown] = useState<OntotisDropDown[]>([]);
  const [positionDropDown, setPositionDropDown] = useState<PositionDropDown[]>([]);
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as { returnTo?: string; id?: string,  address?: string, tk?: string,city?: string, } || {};
  const { returnTo = "/", id = null,  address=null, tk=null,city=null} = state;
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [errors, setErrors] = useState<{ [key: string]: string[] }>({});
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone1: '',
    phone2: '',
    email1: '',
    email2: '',
    address: '',
    city: '',
    postalCode: '',
    ontoti_id: '', // Default to empty to ensure proper selection handling
    position_id: '', // Default to empty to ensure proper selection handling
  });


//console.log('fullPath:', fullPath); // Debugging
//console.log('returnTo:', returnTo);
//console.log('id:', id);
  // Validate and pre-select "Οντότητα" if `id` is valid
  useEffect(() => {
    if (id && !isNaN(Number(id)) && Number(id) >= 0) {
      setFormData((prevData) => ({ ...prevData, ontoti_id: id }));
   
    }
 
   
  }, [id]);
 
  // Load options for "Οντότητα" dropdown
  const loadOntotisDropDown = useCallback(async () => {
    try {
      const response = await getOntotisDropDown();
      if (response) {
        setOntotisDropDown(response);
      } else {
        console.warn('Expected an array but got:', response);
      }
    } catch (error) {
      if (error instanceof ApiError && error.statusCode === 404) {
        return <NotFound />;
        } else {
            console.error('An unexpected error occurred:', error);
            return <GeneralErrorPage />;
        }
    }
  }, []);

  // Load options for "Θέση" dropdown
  const loadPositionDropDown = useCallback(async () => {
    try {
      const response = await getPositionsDropDown();
      if (response) {
        setPositionDropDown(response);
      } else {
        console.warn('Expected an array but got:', response);
      }
    } catch (error) {
      if (error instanceof ApiError && error.statusCode === 404) {
        return <NotFound />;
        } else {
            console.error('An unexpected error occurred:', error);
            return <GeneralErrorPage />;
        }
    }
  }, []);

  // Fetch dropdown options when component mounts
  useEffect(() => {
    loadPositionDropDown();
    loadOntotisDropDown();
  }, [loadPositionDropDown, loadOntotisDropDown]);

  // Handle form field changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (formData) {
      try {
       // console.log(location.state?.fullPath);
       // const returnTo = fullPath
       
       const response = await addPerson(formData); 
       // console.log(fullPath);
         setSuccessMessage('Προστέθηκε με επιτυχία!');
         
         if (id) {
          const returnTo = location.state?.returnTo || "-1";
          setTimeout(() => {
              // Go back to the previous page and pass a `refresh` flag
              navigate(returnTo, { state: { refresh: true } });
            }, 300); // Adjust delay if necessary*/
         /* setTimeout(() => {
            navigate(-1);
          
              window.location.reload();
           
          }, 300);*/
         }else{
          setTimeout(() => {
            navigate(CONFIG.urls.getPersonsUrl_Admin());
            setTimeout(() => {
              window.location.reload();
            }, 100);
          }, 300);
         }
        
      
      } catch (error) {
        handleError(error);
        processError(error, setErrors, setErrorMessage, setSuccessMessage);
                if (error instanceof ApiError && error.statusCode === 404) {
                    return <NotFound />;
                } else {
                    console.error('An unexpected error occurred:', error);
                    return <GeneralErrorPage />;
                }
      }
    }
  };
  const handleAddress = () => {
    if (address && city && tk){
        setFormData((prevData) => ({ ...prevData, 
            address: address, // Replace with parent entity's address
            city: city,      // Replace with parent entity's city
            postalCode: tk,       // Replace with parent entity's postal code
         }));
    }
   
   
};
  return (
    <div className="content">
      <section className="ontotita py-5">
        <div className="container mt-4">
          <div className="card p-5">
            <h2 className="h5 mb-2 text-primary">Προσθήκη Προσώπου</h2>
            <hr />
            <form onSubmit={handleSubmit}>
            
            {successMessage && (
                            <div className="alert alert-success alert-dismissible fade show" role="alert">
                                <strong></strong> {successMessage}
                                <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="alert"
                                aria-label="Close"
                                ></button>
                            </div>
                            )}
                            {errorMessage && (
                            <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                <strong></strong> {errorMessage}
                                <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="alert"
                                aria-label="Close"
                                ></button>
                            </div>
                            )}

              {/* First and Last Name Fields */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="firstName" className="form-label">Όνομα</label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-person"></i></span>
                    <input type="text" id="firstName" name="firstName" className="form-control" required value={formData.firstName} onChange={handleChange} />
                    {errors && errors.hasOwnProperty('firstName') && (<ErrorMessage message={errors.firstName[0]} />)}
                  </div>
                </div>
                <div className="col-md-6">
                  <label htmlFor="lastName" className="form-label">Επώνυμο</label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-person"></i></span>
                    <input type="text" id="lastName" name="lastName" className="form-control" required value={formData.lastName} onChange={handleChange} />
                    {errors && errors.hasOwnProperty('lastName') && (<ErrorMessage message={errors.lastName[0]} />)}
                  </div>
                </div>
              </div>

              {/* Phone Fields */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="phone1" className="form-label">Τηλέφωνο 1</label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-telephone"></i></span>
                    <input type="text" id="phone1" name="phone1" className="form-control" required value={formData.phone1} onChange={handleChange} />
                    {errors && errors.hasOwnProperty('phone1') && (<ErrorMessage message={errors.phone1[0]} />)}
                  </div>
                </div>
                <div className="col-md-6">
                  <label htmlFor="phone2" className="form-label">Τηλέφωνο 2</label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-telephone"></i></span>
                    <input type="text" id="phone2" name="phone2" className="form-control" value={formData.phone2} onChange={handleChange} />
                    {errors && errors.hasOwnProperty('phone2') && (<ErrorMessage message={errors.phone2[0]} />)}
                  </div>
                </div>
              </div>

              {/* Email Fields */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="email1" className="form-label">Email 1</label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-envelope"></i></span>
                    <input type="email" id="email1" name="email1" className="form-control" required value={formData.email1} onChange={handleChange} />
                    {errors && errors.hasOwnProperty('email1') && (<ErrorMessage message={errors.email1[0]} />)}
                  </div>
                </div>
                <div className="col-md-6">
                  <label htmlFor="email2" className="form-label">Email 2</label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-envelope"></i></span>
                    <input type="email" id="email2" name="email2" className="form-control" value={formData.email2} onChange={handleChange} />
                    {errors && errors.hasOwnProperty('email2') && (<ErrorMessage message={errors.email2[0]} />)}
                  </div>
                </div>
              </div>

              {/* Address, City, and Postal Code */}
              <div className="row mb-3">
                <div className="col-md-4">
                  <label htmlFor="address" className="form-label">Διεύθυνση</label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-house-door"></i></span>
                    <input type="text" id="address" name="address" className="form-control" value={formData.address} onChange={handleChange} />
                    {errors && errors.hasOwnProperty('address') && (<ErrorMessage message={errors.address[0]} />)}
                  </div>
                </div>
                <div className="col-md-4">
                  <label htmlFor="city" className="form-label">Πόλη</label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-geo-alt"></i></span>
                    <input type="text" id="city" name="city" className="form-control" value={formData.city} onChange={handleChange} />
                    {errors && errors.hasOwnProperty('city') && (<ErrorMessage message={errors.city[0]} />)}
                  </div>
                </div>
                <div className="col-md-4">
                  <label htmlFor="postalCode" className="form-label">ΤΚ</label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-mailbox"></i></span>
                    <input type="text" id="postalCode" name="postalCode" className="form-control" value={formData.postalCode} onChange={handleChange} />
                    {errors && errors.hasOwnProperty('postalCode') && (<ErrorMessage message={errors.postalCode[0]} />)}
                  </div>
                </div>
              </div>
              <div className="mb-3">
                            {id && address && city && tk && (
                                <button
                                    className="btn btn-secondary btn-sm"
                                    onClick={(e) => {
                                        e.preventDefault(); // Prevent form submission
                                        handleAddress();
                                    }}
                                >
                                    Προσθήκη Δ/νσης Από την Γονική Οντότητα
                                </button>
                            )}
                                </div>
              {/* Ontoti and Position Dropdowns */}
            {/* Ontoti Dropdown */}
            <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="ontoti_id" className="form-label">Οντότητα</label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-diagram-3"></i></span>
                    <select
                      id="ontoti_id"
                      name="ontoti_id"
                      className="form-select"
                      value={formData.ontoti_id}
                      onChange={handleChange}
                    >
                      <option value="">Επιλέξτε Οντότητα</option>
                      {ontotisDropDown.map((item) => (
                        <option key={item.id} value={item.id} disabled={!item.can_edit} >
                          {item.title}
                        </option>
                      ))}
                      
                    </select>
                    {errors?.ontoti_id && <ErrorMessage message={errors.ontoti_id[0]} />}
                  </div>
                </div>
            


                <div className="col-md-6">
                  <label htmlFor="position_id" className="form-label">Θέση</label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-briefcase"></i></span>
                    <select id="position_id" name="position_id" className="form-select" required value={formData.position_id} onChange={handleChange}>
                      <option value="">Επιλέξτε Θέση</option>
                      {positionDropDown.map(item => (
                        <option key={item.id} value={item.id}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                    {errors && errors.hasOwnProperty('position_id') && (<ErrorMessage message={errors.position_id[0]} />)}
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <div className="text-end mt-4">
                <button type="submit" className="btn btn-primary">Αποθήκευση</button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PersonAdd;
